import React from 'react';
import PropTypes from 'prop-types';
import { ShowMCQList } from '../shared';
import { getGCSUrl } from '../../../../services/Common';
import NavigateNextSharpIcon from '@material-ui/icons/NavigateNextSharp';

import './TechLeadNextStack.model.css';
const { Modal } = require('antd');

const TechLeadNextStackModel = ({ visible, onCancel, techLeadNextStack, personalInfo }) => {
  return (<Modal visible={visible} onCancel={onCancel} footer={null}
    destroyOnClose
    className='turing-ui-v2-techleadnextstack-modal'
    centered >
    <div className='turing-ui-v2-techleadnextstack-modal-container'>
      <div className='turing-ui-v2-techleadnextstack-modal-congratulation-text'>
         Congratulations,  {personalInfo && personalInfo.full_name}!
        <div> {"You're a Team Lead"}</div>
      </div>
      <div className='turing-ui-v2-techleadnextstack-modal-pluspoint'>
        {"You're one step closer in finding your next job. Please complete tech stack to be eligible for jobs"}
      </div>
      <div >
        <ShowMCQList workExpCompleted dataSource={techLeadNextStack && techLeadNextStack.MCQList} className={'turing-ui-v2-techleadnextstack-tests-list-container'}>
          {(item) => (
            <div key={item.challenge_id} className={'turing-ui-v2-techleadnextstack-tests-list'} onClick={() => item.start()}>
              <div>
                <img className='turing-ui-v2-techleadnextstack-tests-list-testicon' src={`${getGCSUrl()}/icon/${item.icon}`} width="30px" height="30px"/>
              </div>
              <div>
                <div className={'turing-ui-v2-techleadnextstack-tests-list-challenge-name'}>
                  <p>{item.challenge_name}</p>
                  <div className='turing-ui-v2-techleadnextstack-tests-list-challenge-name-duration'>{`${item.challenge_duration} min`}</div>
                </div>
              </div>
              <div className='turing-ui-v2-techleadnextstack-tests-list-challenge-next'>
                <NavigateNextSharpIcon />
              </div>

            </div>
          )}
        </ShowMCQList>
      </div>

    </div>

  </Modal>);
};

TechLeadNextStackModel.propTypes = {
  visible: PropTypes.bool,
  techLeadNextStack: PropTypes.any,
  onCancel: PropTypes.func,
  personalInfo: PropTypes.object
};

export default TechLeadNextStackModel;
